import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getDeployment } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getFullUrl } from '@/utils/amplitude/analytics/utils/getFullUrl';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

const trackMessageAuctionHouseClicked = (payload: TrackingPayload) => {
    track(TrackingEvents.Checkout.MessageAuctionHouseClicked, payload);
};

export const useTrackMessageAuctionHouseClicked = () => {
    const deployment = useAppSelector(getDeployment);
    const { pathname } = useLocation();

    return useCallback(() => {
        trackMessageAuctionHouseClicked({
            pageName: getAmplitudePageNameFromPath(pathname),
            url: getFullUrl(deployment, pathname),
        });
    }, [deployment, pathname]);
};
